export enum BanheiroTipo {
  DENTRO_RESIDENCIA = 'DENTRO_RESIDENCIA',
  FORA_RESIDENCIA = 'FORA_RESIDENCIA',
  SEM_BANHEIRO = 'SEM_BANHEIRO',
}
